// splide
let collectionSlider = document.querySelector(
  ".splide.smile-collection-slider"
);
let giftCardSlider = document.querySelector(".smile-gift-card-slider");
let smileTestimonial = document.querySelector(".smile-testimonial-slider");
let smileFeaturedCollection = document.querySelector(
  ".splide.luis-collection-slider-splide"
);

if (collectionSlider) {
  let splide_Collection = new Splide(collectionSlider, {
    drag: "free",
    snap: true,
    gap: "19px",
    pagination: false,
    perPage: 1,

  });

  splide_Collection.mount();
}

if (giftCardSlider) {
  new Splide(giftCardSlider, {
    type: "loop",
    drag: "free",
    pauseOnFocus: false,
    pauseOnHover: false,
    focus: "center",
    pagination: false,
    autoplay: false,
    perPage: 3,
    autoScroll: {
      speed: 2,
    },
    arrows: false,
    breakpoints: {
      900: {
        perPage: 1,
        gap: "20px",
      },
        650: {
        perPage: 1.2,
        gap: "5px",
      },
    },
  }).mount(window.splide.Extensions);
}

if (smileTestimonial) {
  let splide_testimonial = new Splide(smileTestimonial, {
    // type: "loop",
    // padding: "5rem",
    drag: "free",
    snap: true,
    gap: "19px",
    pagination: false,
    perPage: 2,
    breakpoints: {
      900: {
        perPage: 2,
        gap: "20px",
      },
      580: {
        perPage: 1,
      },
    },
  });

  splide_testimonial.mount();
}

if (smileFeaturedCollection) {
  new Splide(smileFeaturedCollection, {
    perPage: 3,
    rewind: true,
    gap: "28px",
    arrows: false,
    pagination: false,
    autoplay: true,
    speed: 600, // Transition duration in milliseconds
    easing: 'ease', // Easing function for the transition
    breakpoints: {
      1300: {
        perPage: 2,
      },
      700: {
        perPage: 1,
        gap: "20px",
      },
      600: {
        perPage: 1,
          fixedWidth : '280px',
        gap:"5px",
      },
    },
  }).mount();
}
